const LS_KEY = "rideconnect_geoapify_key";
const LS_STYLE_KEY = "rideconnect_geoapify_map_style";

export function getGeoapifyKey(): string | undefined {
  // 1. Variabile d'ambiente (build-time) ha la precedenza assoluta
  const env = (import.meta.env.VITE_GEOAPIFY_KEY as string | undefined || "").trim();
  if (env) return env;
  // 2. Fallback: chiave inserita manualmente dall'utente nel browser (localStorage)
  try {
    const ls = typeof window !== "undefined" ? window.localStorage.getItem(LS_KEY) : null;
    const v = (ls || "").trim();
    if (v) return v;
  } catch {
    // ignore
  }
  return undefined;
}

/**
 * Geoapify tile style.
 * Examples: osm-carto (default), dark-matter, dark-matter-brown, positron, etc.
 */
export function getGeoapifyMapStyle(): string {
  const env = (import.meta.env.VITE_GEOAPIFY_MAP_STYLE as string | undefined) || "";
  try {
    const ls = typeof window !== "undefined" ? window.localStorage.getItem(LS_STYLE_KEY) : null;
    const v = (ls || "").trim();
    if (v) return v;
  } catch {
    // ignore
  }
  const e = env.trim();
  return e || "osm-carto";
}

export function setGeoapifyMapStyleRuntime(v: string) {
  try {
    const s = (v || "").trim();
    if (!s) window.localStorage.removeItem(LS_STYLE_KEY);
    else window.localStorage.setItem(LS_STYLE_KEY, s);
  } catch {
    // ignore
  }
}

export function setGeoapifyKeyRuntime(v: string) {
  try {
    const s = (v || "").trim();
    if (!s) {
      window.localStorage.removeItem(LS_KEY);
    } else {
      window.localStorage.setItem(LS_KEY, s);
    }
  } catch {
    // ignore
  }
}

export function getGeoapifyKeyMasked(): string {
  const k = getGeoapifyKey();
  if (!k) return "(non impostata)";
  const head = k.slice(0, 4);
  return `${head}••••••••`;
}
